module.exports = __webpack_public_path__ + "static/media/prescription DrugsActive.3d2f6a8b.svg";